import SecondaryButton from '@pages/Admin/CourseSettings/components/SecondaryButton/SecondaryButton'
import cn from './index.module.css'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { selectIsAuth, selectProfile } from '@store/profile.reducer'
import { Spin } from 'antd'
import { useHistory } from 'react-router-dom'
import { LoadingOutlined } from '@ant-design/icons'
import ClassPriceView from '../ClassPriceView/ClassPriceView'
import { usePlatformSettingsString } from '@/hooks/usePlatformSettingsString'

interface ClassEnrollmentFooter {
  showLogIn: boolean
  loading: boolean
  disabledButton?: boolean
  isFree?: boolean
  currentPrice: number
  startPrice?: number | null
  promoDiscount?: IPromoCodeDiscount | null
  onAction: () => void
}

const ClassEnrollmentFooter: FC<ClassEnrollmentFooter> = ({
  showLogIn,
  loading,
  disabledButton,
  isFree,
  currentPrice,
  startPrice,
  promoDiscount,
  onAction,
}) => {
  const history = useHistory()
  const isAuth = useSelector(selectIsAuth)
  const user = useSelector(selectProfile)
  const freeEnrollText = usePlatformSettingsString(
    'isFreeEnrollButtonTitleChanged',
    'freeEnrollButtonTitle',
    'Записаться',
  )

  const onClick = () => {
    history.push('/auth')
  }

  if (showLogIn) {
    return (
      <>
        <div className={cn.hasCourseLabel}>
          На платформе существует кабинет с таким имейлом и в нём уже есть
          данный курс
        </div>
        <div className={cn.footer}>
          <div className={cn.footerActionWrapper}>
            <SecondaryButton className={cn.actionButton} onClick={onClick}>
              Войти
            </SecondaryButton>
          </div>
        </div>
      </>
    )
  }

  return (
    <div className={cn.footer}>
      <ClassPriceView
        isFree={isFree}
        currentPrice={currentPrice}
        startPrice={startPrice}
        promoCode={promoDiscount}
      />
      {(!isAuth || user?.role === 'children') && (
        <div className={cn.footerActionWrapper}>
          {loading && (
            <Spin
              className={cn.footerActionSpinner}
              indicator={
                <LoadingOutlined
                  spin
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                />
              }
            />
          )}
          <SecondaryButton
            className={cn.actionButton}
            onClick={onAction}
            disabled={loading || disabledButton}
          >
            {isFree ? freeEnrollText : 'Купить'}
          </SecondaryButton>
        </div>
      )}
    </div>
  )
}

export default ClassEnrollmentFooter
